import gql from "graphql-tag";

export default gql`
  mutation ForgotPassword($email: EmailAddress!, $turnstileToken: String!, $turnstileIdempotencyKey: String) {
    forgotPassword(email: $email, turnstileToken: $turnstileToken, turnstileIdempotencyKey: $turnstileIdempotencyKey)
  }
`;
